import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store/store";
// Styles
import "./css/index.css";
import "./css/chart.css";
import "./css/step.css";
import "./css/style.css";

// Route Config
import routesConfig from "./routes/routesConfig";

// Components
import Layout from "./Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./layouts/ScrollToTop";
import Loader from "./components/Loader";

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <Suspense fallback={<Loader />}>
          <Routes>
            {/* Dynamic Rendering of Routes from Config */}
            {routesConfig.map((route, index) => {
              const { path, element, protected: isProtected, layout, permission } = route;

              // 1. Wrap in PermissionRoute if permission required
              let content = element;

              // 2. Wrap in Layout if required
              if (layout) {
                content = (
                  <Layout>
                    {content}
                  </Layout>
                );
              }

              // 3. Wrap in ProtectedRoute if required
              if (isProtected) {
                content = (
                  <ProtectedRoute permissions={permission}>
                    {content}
                  </ProtectedRoute>
                );
              }

              return <Route key={index} path={path} element={content} />;
            })}
          </Routes>
        </Suspense>
        <ScrollToTop />
      </PersistGate>
    </Provider>
  );
};

export default App;
